import classNames from 'classnames';

type UploadImageIconProps = {
  className?: string;
};

export const UploadImageIcon = ({
  className = 'h-5 w-5 text-primary-container',
}: UploadImageIconProps) => {
  return (
    <svg
      aria-hidden='true'
      className={classNames(className)}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 640 512'
    >
      <path
        className='text-current'
        fill='currentColor'
        d='M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 96.7c-5.3-.5-10.6-.7-16-.7c-10.9 0-21.6 1-32 2.9L464 96c0-8.8-7.2-16-16-16L64 80c-8.8 0-16 7.2-16 16l0 320 0 .3 4.5-6.2 80-112C137 291.7 144.2 288 152 288s15 3.7 19.5 10L202 340.7l83-107.4c4.6-5.9 11.6-9.3 19-9.3s14.5 3.4 19 9.3l27.5 35.6C331.3 297.1 320 331.3 320 368c0 42.5 15.1 81.6 40.3 112L64 480c-35.3 0-64-28.7-64-64L0 96zm102.4 56c8.6-14.9 24.4-24 41.6-24s33 9.1 41.6 24s8.6 33.1 0 48s-24.4 24-41.6 24s-33-9.1-41.6-24s-8.6-33.1 0-48zM352 368c0-51.4 27.4-99 72-124.7s99.4-25.7 144 0s72 73.3 72 124.7s-27.4 99-72 124.7s-99.4 25.7-144 0S352 419.4 352 368zm76.7-19.3c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L480 342.6l0 89.4c0 8.8 7.2 16 16 16s16-7.2 16-16l0-89.4 28.7 28.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-56-56c-6.2-6.2-16.4-6.2-22.6 0c-18.7 18.7-37.3 37.3-56 56z'
      />
    </svg>
  );
};
